import "./style.scss";
import HeroSlider from "../../components/HeroSlider";
import StoryTilesSwiper from "../../components/StoryTilesSwiper";
import ActivityCard from "../../components/ActivityCard";
import SectionHeader from "@components/SectionHeader";
import AwardCard from "../../components/AwardCard";
import { staticCoupon } from "../../Constants";
import {
  HOMEPAGE_CACHE_TIME,
  HOMEPAGE_STALE_TIME,
  getActivationHomepageList,
  getCouponHomepageList,
} from "../../api/homepage";
import { useQuery } from "@tanstack/react-query";
import {
  applySortCouponsRules,
  isCouponInStock,
  isCouponSoldOut,
  filterDjConsoleActivations,
} from "../../Helpers";
import { EasterEgg } from "@pages/EasterEggPage";
import {
  DETAILS_CACHE_TIME,
  DETAILS_STALE_TIME,
  getUserDetails,
} from "@api/consumer";
import { useEffect, useState } from "react";

export default function HomePage() {
  const { data: coupons, isLoading: isLoadingCoupons } = useQuery({
    queryKey: ["homepage-coupons-list"],
    queryFn: () => getCouponHomepageList(),
    staleTime: HOMEPAGE_STALE_TIME,
    cacheTime: HOMEPAGE_CACHE_TIME,
  });
  const sortedCoupons = applySortCouponsRules(coupons?.catalogue);
  const threeCoupons = sortedCoupons.slice(0, 3);
  const threeCouponsWithStatic = [staticCoupon, ...sortedCoupons.slice(0, 2)];
  const partnerAvailable = coupons?.partnerAvailable;

  console.log("threeCouponsWithStatic", threeCouponsWithStatic);

  const { data: activities, isLoading: isLoadingActivities } = useQuery({
    queryKey: ["homepage-activities-list"],
    queryFn: () => getActivationHomepageList(),
    staleTime: HOMEPAGE_STALE_TIME,
    cacheTime: HOMEPAGE_CACHE_TIME,
  });

  const { data: details } = useQuery({
    queryKey: ["user-details"],
    queryFn: () => getUserDetails(),
    staleTime: DETAILS_STALE_TIME,
    cacheTime: DETAILS_CACHE_TIME,
  });

  const registerSource = details?.consumer?.registerSource;
  const filteredActivities = filterDjConsoleActivations(
    activities,
    registerSource,
  );

  const [activeSkin, setActiveSkin] = useState(() => {
    const stored = localStorage.getItem("activeSkin");
    return stored || null;
  });

  useEffect(() => {
    const updateSkin = () => {
      const stored = localStorage.getItem("activeSkin");
      setActiveSkin(stored || null);
    };

    window.addEventListener("skinChange", updateSkin);
    return () => window.removeEventListener("skinChange", updateSkin);
  }, []);

  return (
    <section className={`home-page ${activeSkin ? `skin-${activeSkin}` : ""}`}>
      <HeroSlider />
      <StoryTilesSwiper />
      <div className="awards-section">
        <SectionHeader href="/coupons">
          <strong> Gutscheine </strong> erwerben
        </SectionHeader>
        <div className="award-tiles">
          {threeCoupons?.map((e, index) => (
            <AwardCard
              brands={e.brands}
              copy={e.content.title}
              mobileImg={e.thumbnail?.file?.url}
              desktopImg={e.hero_image?.file?.url}
              imgDesc={e.hero_image?.metadata?.imgDesc}
              highlighted={e.highlighted}
              points={e.price}
              key={index}
              availableForStatus={e.hasLevel}
              ident={e.ident}
              level={e.level}
              inStock={isCouponInStock(e)}
              hasPoints={e.hasPoints}
              hasLevel={e.hasLevel}
              partner={e.partner}
              partnerAvailable={partnerAvailable}
              onClick={e.onClick}
              availabilityLevel={e.availabilityLevel}
              disabled={
                isCouponSoldOut(e.availabilityLevel) ||
                !isCouponInStock(e) ||
                !e.hasLevel ||
                !e.hasPoints ||
                (e.partner && !partnerAvailable)
              }
            />
          ))}
        </div>
      </div>
      <div className="activities-section">
        {/* <EasterEgg ident={"halloween2025_7"} direction="right" /> */}
        <SectionHeader href="/activities">
          <strong>Punkte </strong>sammeln
        </SectionHeader>
        <div className="activitity-tiles">
          {filteredActivities?.map((activation, index) => (
            <ActivityCard
              key={index}
              mobileImg={activation?.thumbnail?.file?.url}
              desktopImg={activation?.hero_image?.file?.url}
              imgDesc={activation?.hero_image?.metadata?.imgDesc}
              copy={activation?.content?.description}
              points={activation.payout}
              brands={activation.brands}
              completed={activation.completed}
              ident={activation.ident}
              type={activation.type}
              highlighted={activation.highlighted}
            />
          ))}
        </div>
      </div>

      <div className="health-template">
        {details?.consumer.brands?.includes("vuse") && (
          <div className="inner-template">
            <span>Vuse: </span>
            <br /> *Basierend auf dem von Vuse geschätzten Marktanteil
            (Wertanteil) von Vapour Pods und vorgefüllten Geräten, abgeleitet
            von der unverbindlichen Preisempfehlung im gemessenen Einzelhandel
            (d.h. dem Gesamtwert der Kategorie E-Zigarette im
            Einzelhandelsumsatz) in den Hauptmärkten für Vapour: USA, Kanada,
            Frankreich, Großbritannien, Deutschland, Polen und Spanien (Stand
            Dezember 2024).
            <br />
            **Vuse-Produkte sind nicht risikofrei und enthalten Nikotin, eine
            abhängig machende Substanz. Dies ist ein Vergleich zwischen dem
            Rauch einer wissenschaftlichen Referenzzigarette (ca. 9 mg Teer) und
            den Emissionen der Produkte Vuse GO 1000 sowie Vuse Pro One und Vuse
            Ultra bei Verwendung mit Vuse Pods. Der Vergleich bezieht sich auf
            den Durchschnitt von 9 schädlichen Komponenten, deren Reduktion im
            Zigarettenrauch aufgrund unabhängiger Bewertung als vorrangig
            identifiziert wurde.
          </div>
        )}
        {details?.consumer.brands?.includes("glo") && (
          <div className="inner-template">
            <span>glo™: </span>
            <br />
            *Wir entwickeln glo™ kontinuierlich weiter. glo™ erhitzt speziell
            entwickelte Sticks anstatt sie zu verbrennen. Dabei entsteht ein
            Aerosol, weniger Geruch und keine Asche im Vergleich zu einer
            gerauchten Zigarette. Dieses Produkt ist nicht risikofrei.
          </div>
        )}
      </div>
    </section>
  );
}
